import * as React from 'react';

export class PanelIcon extends React.Component<{}, {}> {

  render() {
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="18" 
            height="18" 
            viewBox="0 0 18 18"
        >
            <path d="M12.44 6.44L9 9.88 5.56 6.44 4.5 7.5 9 12l4.5-4.5z"/>
        </svg>
    );
  }
}
